<router-outlet></router-outlet>

<!-- AI Chatbot -->
<app-ai-chatbot (actionRequested)="handleChatbotAction($event)"></app-ai-chatbot>